import { useEffect } from "react";
import { PlusIcon } from "lucide-react";
import { useNavigate } from "react-router";

import {
  Column,
  ErrorText,
  LoadingIndicator,
  TopbarContainer,
  TopbarTitle,
} from "@/components";
import { SignupVariantsTable } from "@/components/tools/SignupVariantsTable";
import { Button } from "@/components/ui/button";

import { useSetTitle } from "@/hooks/useSetTitle";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS, MIXPANEL_SUBSCREENS } from "@/lib/mixpanel/types";
import { novaClient } from "@/lib/trpc";

export const ToolsSignupVariantsListPage = () => {
  const navigate = useNavigate();

  const { data: signupVariants, status } =
    novaClient.internal.admin.dynamicPageVariants.findAll.useQuery();

  useSetTitle({
    title: "Tools | Signup Variants",
  });

  useEffect(() => {
    mixpanelUtils.trackScreenView(MIXPANEL_SCREENS.SIGNUP_VARIANTS, {
      subScreenName: MIXPANEL_SUBSCREENS.LIST,
    });
  }, []);

  return (
    <Column className="h-svh">
      <TopbarContainer>
        <TopbarTitle>Signup Variants</TopbarTitle>
        <Button
          className="rounded-full"
          onClick={() => {
            mixpanelUtils.trackButtonClick(
              "Create signup variant",
              MIXPANEL_SCREENS.SIGNUP_VARIANTS,
            );
            void navigate("/tools/signup-variants/create");
          }}
        >
          <PlusIcon className="h-4 w-4" />
          Create signup variant
        </Button>
      </TopbarContainer>
      <Column className="flex-1 overflow-hidden p-6">
        {status === "pending" && <LoadingIndicator variant="medium" />}
        {status === "error" && (
          <ErrorText errorMessage="Error loading signup variants." />
        )}
        {status === "success" && (
          <SignupVariantsTable signupVariants={signupVariants} />
        )}
      </Column>
    </Column>
  );
};
